import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ObbligoProvider {
  private _obbligoDetails$ = new BehaviorSubject<any>(null);

  setObbligoDetails(obbligoDetails: any): void {
    return this._obbligoDetails$.next(obbligoDetails);
  }

  getObbligoDetails(): any {
    return this._obbligoDetails$.getValue();
  }

  get obbligoDetails$(): Observable<any> {
    return this._obbligoDetails$.asObservable();
  }

  clearObbligoDetails(): void {
    this._obbligoDetails$.next(null);
  }
}
